import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ConsumableEditPage } from './consumable-edit';
import { SharedModule } from '../../../shared/shared.module';
import { FoundationModule } from '../../../../_foundation/foundation.module';
import { ConsumableEditComponentComponent } from '../consumable-edit-component/consumable-edit-component.component';
import { TextMaskModule } from 'angular2-text-mask';
import { DirectivesModule } from '../../../../directives/directives.module';
import { DailyLogPageModule } from '../../../daily-log/daily-log/daily-log.module';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

@NgModule({
  declarations: [
    ConsumableEditPage,
    ConsumableEditComponentComponent
  ],
    imports: [
        DirectivesModule,
        IonicPageModule.forChild(ConsumableEditPage),
        SharedModule,
        FoundationModule,
        TextMaskModule,
        DailyLogPageModule,
        DropDownsModule
    ],
})
export class ConsumableEditPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/consumables/consumable-edit/consumable-edit.module.ts